import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const Deezer: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 95 19" fill="none" {...props}>
      <path
        d="M22.138 12c0 3.793 2.335 6.063 5.806 6.063 1.73 0 3.187-.483 4-1.75v1.75h3.168V0h-3.29v7.679c-.748-1.267-2.128-1.835-3.859-1.835-3.385-.01-5.825 2.308-5.825 6.157zm9.787 0c0 2.166-1.475 3.519-3.243 3.519-1.835 0-3.244-1.353-3.244-3.518 0-2.204 1.419-3.584 3.244-3.584 1.768 0 3.244 1.4 3.244 3.584zm13.43 1.4c-.38 1.4-1.334 2.1-2.838 2.1-1.75 0-3.187-1.06-3.225-2.932h8.294c.104-.463.151-.955.151-1.494 0-3.357-2.288-5.249-5.664-5.249-3.603 0-6.081 2.563-6.081 6.043 0 3.878 2.733 6.204 6.516 6.204 2.856 0 4.794-1.192 5.645-3.565L45.354 13.4zm-6.063-3.026c.313-1.352 1.438-2.147 2.79-2.147 1.475 0 2.478.795 2.478 2.043l-.02.104h-5.248zM57.563 13.4c-.378 1.4-1.333 2.1-2.837 2.1-1.75 0-3.187-1.06-3.225-2.932h8.294a6.78 6.78 0 00.151-1.494c0-3.357-2.288-5.249-5.664-5.249-3.604 0-6.081 2.563-6.081 6.043 0 3.878 2.733 6.204 6.516 6.204 2.855 0 4.794-1.192 5.645-3.565L57.563 13.4zm-6.062-3.026c.312-1.352 1.438-2.147 2.79-2.147 1.475 0 2.478.795 2.478 2.043l-.02.104h-5.248zm20.058 7.707v-2.978h-6.913l6.724-6.545V5.835H60.731v2.837h6.497l-6.705 6.572v2.837h11.036zm9.618-4.68C80.798 14.8 79.843 15.5 78.34 15.5c-1.75 0-3.187-1.06-3.225-2.932h8.294a6.78 6.78 0 00.15-1.494c0-3.357-2.288-5.249-5.664-5.249-3.603 0-6.08 2.563-6.08 6.043 0 3.878 2.733 6.204 6.515 6.204 2.856 0 4.795-1.192 5.646-3.565l-2.8-1.107zm-6.062-3.027c.312-1.352 1.437-2.147 2.79-2.147 1.475 0 2.477.795 2.477 2.043l-.019.104h-5.248z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.706 5.835h4.057V8.21h-4.057V5.835z"
        fill="#40AB5D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.706 9.126h4.057v2.373h-4.057V9.127z"
        fill="url(#prefix__paint0_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.706 12.417h4.057v2.374h-4.057v-2.374z"
        fill="url(#prefix__paint1_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 15.708h4.057v2.374H0v-2.374z"
        fill="url(#prefix__paint2_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.897 15.708h4.057v2.374H4.897v-2.374z"
        fill="url(#prefix__paint3_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.808 15.708h4.057v2.374H9.808v-2.374z"
        fill="url(#prefix__paint4_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.706 15.708h4.057v2.374h-4.057v-2.374z"
        fill="url(#prefix__paint5_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.808 12.417h4.057v2.374H9.808v-2.374z"
        fill="url(#prefix__paint6_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.897 12.417h4.057v2.374H4.897v-2.374z"
        fill="url(#prefix__paint7_linear_6273_10627)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.897 9.126h4.057v2.373H4.897V9.127z"
        fill="url(#prefix__paint8_linear_6273_10627)"
      />
      <path
        d="M91.362 10.063v.35h3.206v-.937c0-2.1-1.315-3.622-3.518-3.622-1.419 0-2.421.69-2.941 1.835V5.854h-3.31v12.228h3.31v-7.878c0-1.248.671-1.938 1.702-1.938.946.01 1.55.898 1.55 1.796z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_6273_10627"
          x1={16.755}
          y1={11.52}
          x2={16.716}
          y2={9.091}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#358C7B" />
          <stop offset={0.526} stopColor="#33A65E" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_6273_10627"
          x1={14.646}
          y1={14.669}
          x2={18.825}
          y2={12.54}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222B90" />
          <stop offset={1} stopColor="#367B99" />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear_6273_10627"
          x1={0.001}
          y1={16.896}
          x2={4.054}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F90" />
          <stop offset={1} stopColor="#FF8000" />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear_6273_10627"
          x1={4.902}
          y1={16.896}
          x2={8.956}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8000" />
          <stop offset={1} stopColor="#CC1953" />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear_6273_10627"
          x1={9.806}
          y1={16.896}
          x2={13.86}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC1953" />
          <stop offset={1} stopColor="#241284" />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear_6273_10627"
          x1={14.704}
          y1={16.896}
          x2={18.757}
          y2={16.896}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#222B90" />
          <stop offset={1} stopColor="#3559A6" />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear_6273_10627"
          x1={9.647}
          y1={14.244}
          x2={14.02}
          y2={12.965}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC1953" />
          <stop offset={1} stopColor="#241284" />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear_6273_10627"
          x1={4.758}
          y1={12.815}
          x2={9.1}
          y2={14.395}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.003} stopColor="#FC0" />
          <stop offset={1} stopColor="#CE1938" />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear_6273_10627"
          x1={5.243}
          y1={8.757}
          x2={8.615}
          y2={11.869}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.003} stopColor="#FFD100" />
          <stop offset={1} stopColor="#FD5A22" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const MemoDeezer = React.memo(Deezer);
export default MemoDeezer;
